var config = {
    NOTESHEETLINK: 'https://turingmachine.info/files/notesheet.pdf',
    RULESLINK: 'https://turingmachine.info/files/rules/',
    CHALLENGEBANKLINK: 'https://turingmachine.info/files/TM_OfflineChallengeBank_1',
    FOLDER_IMAGES_LAWS: 'https://turingmachine.info/images/laws/',
    FOLDER_IMAGES_CARDS: 'https://turingmachine.info/images/criteriacards/',
    API: 'https://turingmachine.info/api/'
};
export default config;